import { api } from '../api';
import { urls } from 'api/urls';

const getCnpj = async (cnpj: string) => await api.get(`${urls.cnpj}/${cnpj}`);

export { getCnpj };
